var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/check_white.94145185.png","uri@2x": __webpack_public_path__ + "static/media/check_white.5ec90234.png","uri@3x": __webpack_public_path__ + "static/media/check_white.00e8d535.png",
    width: 18,
    height: 14
});